module.exports = __webpack_public_path__ + "images/4abdacdb303dd84b27da774d276e077b-quark.png";